var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paste_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#0071B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.79,21.806h-2.071v-8h3.071c3.859,0,7,3.14,7,7V40h-8V21.806z M10.79,21.806h1.867v-8H9.79c-3.86,0-7,3.14-7,7v53 c0,3.859,3.14,7,7,7H32v-8H10.79V21.806z M50.63,23.605H18.95v-9.123c0-7.554,6.146-13.699,13.699-13.699h4.281 c7.554,0,13.7,6.146,13.7,13.699V23.605z M42.95,14.482c0-3.319-2.7-6.02-6.02-6.02h-4.281c-3.319,0-6.02,2.7-6.02,6.02v1.443h16.32 V14.482z M88,53v25c0,1.061-0.422,2.078-1.172,2.828l-14,14C72.078,95.578,71.061,96,70,96H45c-3.86,0-7-3.141-7-7V53 c0-3.859,3.14-7,7-7h36C84.859,46,88,49.141,88,53z M46,88h20.487v-5.32c0-4.518,3.675-8.192,8.192-8.192H80V54H46V88z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.a74b99c67e7bb4f27e549d1af1dbe71b.svg";
export { ForwardRef as ReactComponent };